import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import Resources from '../resourceLinks/ResourceLinks';
import TextArea from './ShortResponseTextArea';
import Question from './ShortResponseQuestion';
import Feedback from './ShortResponseFeedbackReview';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as userDataActions from '../../../actions/userDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as xAPIHelper from '../../../helpers/xAPIHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as localStorage from '../../../localStorage/localStorage';
import _ from 'lodash';

class ShortResponseReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            responseData: this.props.responseData,
            shortResponseQuestions: this.props.shortResponseQuestions,
            questionsRespondedTo: [],
            kpis: [],
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            renderQuestions: false,
            renderedQuestions: [],
            displayInline: this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_INLINE || (this.props.screenObject.respond_type === objectConstants.RESPOND_TYPE_ELSEWHERE_IF_SCORM && this.props.contentData.experience.tracking_type !== appConstants.TRACKING_TYPE_SCORM),
            submitted: true,
            showFeedback: true,
            selfRate: this.props.screenObject.assess_type !== objectConstants.ASSESSED_TYPE_NONE,
            saveRating: this.props.screenObject.assess_type === objectConstants.ASSESSED_TYPE_SCORED && appHelper.isDefined(appHelper.getBite(this.props.responseData.bite_id).score_kpi),
            callbacks: {},
            showProgressionButton: false,
            assetData: {},
            screenStatus: "",
            checkComplete: false,
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: false,
            allowScroll: appHelper.allowScroll(this.props.responseData.bite_id, this.props.responseData.screen_id, this.props.screenObject.asset_id),
            submit_label: appHelper.getLocaleString("submit_label")
        };

        this.onShowComplete = this.onShowComplete.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.onRendered = this.onRendered.bind(this);
        this.setRenderedQuestions = this.setRenderedQuestions.bind(this);
        this.getXAPIResponse = this.getXAPIResponse.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
    }

    componentDidMount() {
        this.setRenderedQuestions();
        this.setResources();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }
        if (this.state.shortResponseQuestions !== nextProps.shortResponseQuestions) {
            this.setState({shortResponseQuestions: Object.assign([], nextProps.shortResponseQuestions)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                submit_label: appHelper.getLocaleString("submit_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkGetXAPIResponse) {
            this.getXAPIResponse();
        }

    }

    setCallbacks() {

    }


    setRenderedQuestions() {
        let renderedQuestions = [];
        let allQuestions = Object.assign([], this.state.shortResponseQuestions);
        _.forEach(this.state.screenObject.questions, function (question) {
            let questionData = appHelper.getArrayObjectByKey(allQuestions, "id", question.id);


            if (appHelper.isDefined(questionData.id)) {
                renderedQuestions = dataHelper.immutablePush(renderedQuestions, questionData);
            }
        });

        this.setState({
            renderQuestions: localStorage.tracking_type !== appConstants.TRACKING_TYPE_XAPI && localStorage.tracking_type !== appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2,
            renderedQuestions: Object.assign([], renderedQuestions),
            checkGetXAPIResponse: true,

        });
    }

    getXAPIResponse() {
        this.setState({checkGetXAPIResponse: false});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            let renderedQuestions = Object.assign([], this.state.renderedQuestions);
            let returnedResponses = 0;
            let parentScreen = this.props.callbacks.getSubScreenParent();
            let params = {
                renderedQuestions: this.state.renderedQuestions,
                bite_id: this.props.callbacks.getBiteId(),
                screen_id: this.props.callbacks.getScreenId(),
                parent_screen_id: appHelper.isDefined(parentScreen) ? parentScreen.screen_id : undefined,
                asset_id: this.state.screenObject.asset_id,
            };

            let interactionDataArray = xAPIHelper.getShortResponseIds(this.state.screenObject, params);

            for (let i = 0; i < interactionDataArray.length; i++) {
                let interactionData = interactionDataArray[i];
                this.props.actions.getActvityStatement(interactionData).then((responseObj) => {
                    if (appHelper.isDefined(responseObj.statement)) {
                        let response = responseObj.statement.result.response;
                        let responseQuestion = appHelper.getArrayObjectByKey(renderedQuestions, "id", responseObj.id);
                        let responseQuestionIndex = appHelper.getArrayObjectIndexByKey(renderedQuestions, "id", responseObj.id);
                        responseQuestion = Object.assign({}, responseQuestion, {
                            response: response,
                        });

                        renderedQuestions = dataHelper.immutableSplice(renderedQuestions, responseQuestionIndex, 1, responseQuestion);
                        returnedResponses++;
                        if (returnedResponses === renderedQuestions.length) {
                            this.setState({
                                renderedQuestions: Object.assign([], renderedQuestions),
                                renderQuestions: true
                            });
                        }
                    } else {
                        this.setState({renderQuestions: true});
                    }

                }).catch(error => {
                });
            }
        }

    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.screenObject);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }


    onRendered() {

    }

    onShowComplete() {
        this.setState({isVisible: true, checkComplete: false});
    }


    onResourcesComplete() {

    }


    render() {
        return (
            <div className={`learner-action`}>
                {
                    appHelper.isDefined(this.props.characterPose) && appHelper.isDefined(this.props.characterPose.src) && this.props.characterPose.src.length > 0
                        ?
                        <div className={`content-character-expression`}>
                            <img src={this.getImagePath(this.props.characterPose.src)} alt=""/>
                        </div>
                        :
                        null
                }
                <div className={`question-wrapper`}>
                    <div className="object-container">
                        {
                            this.state.screenObject.show_title
                                ? <h4 className={this.state.screenObject.title_style} dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                : null
                        }

                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0 && this.state.locale.description !== "<p><br></p>"
                                ?
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                :
                                null
                        }

                        {
                            this.state.hasResources
                                ?
                                <div>
                                    <br/>
                                    <Resources resources={this.state.resourceLinks}
                                               onResourcesComplete={this.onResourcesComplete}/>
                                </div>
                                :
                                null
                        }


                        {
                            this.state.showFeedback && this.state.screenObject.feedback_type === objectConstants.FEEDBACK_TYPE_INCLUDE
                                ?
                                <div>
                                    <br/>
                                    <Feedback screenObject={this.state.screenObject}
                                              responseData={this.state.responseData} callbacks={this.state.callbacks}
                                              scrollToFeedback={this.scrollToFeedback}
                                              onComplete={this.onFeedbackComplete} selfRate={this.state.selfRate}
                                              saveRating={this.state.saveRating}/>
                                </div>
                                : null
                        }
                        <br/>
                        {
                            this.state.renderQuestions
                                ?
                                this.state.renderedQuestions.map(question =>
                                    <div key={question.id}>
                                        {this.state.displayInline
                                            ?
                                            <TextArea parentObject={this.state.screenObject}
                                                      screenObject={question}
                                                      callbacks={this.state.callbacks}
                                                      submitted={this.state.submitted}
                                            />
                                            :
                                            <Question parentObject={this.state.screenObject}
                                                      screenObject={question}
                                                      callbacks={this.state.callbacks}/>
                                        }
                                    </div>
                                )
                                :
                                <div className="pl-circle content">
                                    <div className="pl-circle1 pl-child"/>
                                    <div className="pl-circle2 pl-child"/>
                                    <div className="pl-circle3 pl-child"/>
                                    <div className="pl-circle4 pl-child"/>
                                    <div className="pl-circle5 pl-child"/>
                                    <div className="pl-circle6 pl-child"/>
                                    <div className="pl-circle7 pl-child"/>
                                    <div className="pl-circle8 pl-child"/>
                                    <div className="pl-circle9 pl-child"/>
                                    <div className="pl-circle10 pl-child"/>
                                    <div className="pl-circle11 pl-child"/>
                                    <div className="pl-circle12 pl-child"/>
                                </div>
                        }

                        {
                            !this.state.submitted && this.state.displayInline
                                ? <Button label={this.state.submit_label}
                                          id={`${this.state.screenObject}_button`}
                                          onClick={this.onSubmit}/>

                                : null
                        }


                    </div>
                </div>
            </div>
        );
    }
}

ShortResponseReview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    responseData: PropTypes.object.isRequired,
    callbacks: PropTypes.object,
    shortResponseQuestions: PropTypes.array.isRequired,
    characterPose: PropTypes.object,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ShortResponseReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        shortResponseQuestions: state.userData.short_response_questions,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortResponseReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/ShortResponseReview.js
 **/